<template>
  <div class="ContactList">
    <ComTitlte titleEn="CONTACT METHOD" titleZh="联系方式"></ComTitlte>
    <div class="cont">
      <div
        v-for="(item, index) in contactList"
        :key="index"
        class="item_contact"
      >
        <div class="title">{{ item.title }}</div>
        <el-tooltip placement="top">
          <div slot="content">
            <div class="c_titleTips">
              {{ item.desc }}
            </div>
          </div>
          <div class="desc">{{ item.desc }}</div>
        </el-tooltip>
        <div class="name">
          <span class="lable">联系人：</span>
          <span class="value">{{ item.name }}</span>
        </div>
        <div class="phone" style="display: flex">
          <span class="lable">联系电话：</span>
          <div style="margin-top: 6px">
            <p
              v-for="i in item.phone"
              :key="i"
              class="value"
              style="line-height: 20px"
            >
              {{ i }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";

export default {
  name: "ContactList",
  data() {
    return {
      contactList: [
        {
          title: "所长办公室",
          desc: "负责主持事务所全面工作，业务拓展。",
          name: "陈洁",
          phone: ["020-83523942"],
        },
        {
          title: "专项统计部",
          desc: "专项统计部主要负责专项统计与统计数据咨询项目，包括大型普查、行业/部门专项统计调查、统计培训、基础数据采集与监测、统计数据建模、数据研究分析与课题研究等。",
          name: "李玉玲",
          phone: ["020-33971929"],
        },
        {
          title: "社情民意研究部",
          desc: "社情民意调查部主要负责社情民意调查研究，包括满意度调查、绩效调查、城乡社会经济状况调查、社情民意调查/社会舆论调查、社会问题调查、公共社会政策调研、公益性社会调查、居民生活状况调查、社会心理调查、承接学术性课题调研项目实地执行工作等。",
          name: "谭艳璐",
          phone: ["020-83184124"],
        },
        {
          title: "市场部",
          desc: "市场部主要负责客户服务及政企业务市场拓展工作。",
          name: "梁志联",
          phone: ["19202095032"],
        },
        {
          title: "调查中心",
          desc: "主要负责承接和统筹调查项目执行，覆盖全国CATI业务、街访和神秘客业务、录音录像审核项目、online业务等。",
          name: "石丽燕、邓嘉成",
          phone: ["18922111163", "020-81535265"],
        },
        {
          title: "综合管理部",
          desc: "综合管理部主要负责财务、人事、后勤等方面的事务",
          name: "谢燕珺",
          phone: ["020-83183164"],
        },
      ],
    };
  },
  components: { ComTitlte },
};
</script>
<style lang="scss">
.c_titleTips {
  display: block;
  width: 340px;
  line-height: 20px;
  font-size: 12px;
}
</style>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.ContactList {
  width: $themeMinWidth;
  margin: 0 auto;
  position: relative;

  .cont {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 40px 0 0 0;

    .item_contact {
      width: 340px;
      height: 184px;
      background-color: #ffffff;
      border: solid 1px #e8e8e8;
      padding: 0 20px;
      box-sizing: border-box;
      margin: 0 0 30px 0;

      .title {
        width: 130px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 16px;
        color: #ffffff;
        background-color: #406cdd;
        border-radius: 0px 0px 10px 10px;
        margin: 0 auto;
      }

      .desc {
        height: 48px;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
        margin: 10px 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .phone,
      .name {
        padding: 0 0 0 24px;
        position: relative;

        &::before {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate(0, -50%);
          content: "";
          display: inline-block;
          width: 18px;
          height: 17px;
        }

        .lable {
          font-size: 16px;
          line-height: 30px;
          color: #333333;
        }

        .value {
          font-size: 16px;
          color: #666666;
        }
      }

      .name::before {
        background: url("../../assets/img/contactus/a_icon_name.png") center
          no-repeat;
        background-size: contain;
      }

      .phone::before {
        background: url("../../assets/img/contactus/a_icon_phone.png") center
          no-repeat;
        background-size: contain;
        top: 15px;
      }
    }
  }
}
</style>
